<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo-small.png" alt="" style="max-width: 40px; margin: 10px auto; ">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logoesign.png" alt="" style="width: 100px; margin: 10px auto; ">
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logolight2.png" alt="" style="width: 80px; margin: 10px auto; ">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logolight.png" alt="" style="width: 100px; margin: 10px auto; ">
          </span>
        </a>
      </div>

    </div>

    <div class="d-flex align-items-center gap-2">

      <button type="button" class="btn btn-primary btn-sm d-flex align-items-center gap-1" routerLink="/"
        title="Go to home page">
        <i class="ri-home-4-line"></i>
        <span class="d-none d-sm-inline">Home</span>
      </button>

    </div>
  </div>
</header>